import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserToken } from "../../domain/model/user-token";
import { InternalApiRepo } from "../../domain/internal-api.repo";
import { UserTokenWS } from "../network/user-token.ws";

/**
 * Repository used to use internal api endpoints.
 */
@Injectable()
export class InternalApiDataRepo implements InternalApiRepo {
  constructor(private userTokenWS: UserTokenWS) {}

  /**
   * Get user token.
   * @param email
   * @param token user token authentication
   */
  getUserToken(email: string, token: string): Observable<UserToken> {
    return this.userTokenWS.execute(email, token);
  }
}
